<script>
import { Bar } from 'vue-chartjs'
import axios from 'axios'

export default {
    extends: Bar,
    props:[
        'catid','selector','name','currentFund'
    ],
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{
                    label: 'Passive',
                    data: [],
                    backgroundColor: "#AFEF97"
                },{
                    label: 'Active',
                    data: [],
                    backgroundColor: "#FF8886"
                },{
                    label: 'This Fund',
                    data: [],
                    backgroundColor: "#181818"
                }]
            },
            options: {
                tooltips:{
                  enabled:false
                },
                legend: {
                    display: true,
                },
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [{
                        scaleLabel: {
                            display: true,
                            labelString: this.name
                        },
                    }],

                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: 'Number of funds'
                        },
                        ticks: {
                            suggestedMin: 0,
                            precision:0

                            // minimum will be 0, unless there is a lower value.
                            // OR //
                            //beginAtZero: true   // minimum value will be 0.
                        }

                    }]
                }

            }
        }
    },
    methods:{
        getChart(){
            axios.get('/search/percentile-chart', {params: {
                    category: this.catid,
                    native: this.$store.state.search.currency,
                    selector:this.selector
                }})
                .then((response) => {
                    let list = [];
                    for (let i = response.data["min"]; i <= response.data["max"]; i=i+response.data["ticks"]) {
                        if(response.data["ticks"] == 0.1){
                            list.push(String(i.toFixed(1)));
                        }
                        else{
                            list.push(i);
                        }
                    }
                    this.chartData.labels = list
                    this.chartData.datasets[0].data= response.data["passive"]
                    this.chartData.datasets[1].data= response.data["active"]

                    this.chartData.datasets[0].data.sort((a, b) => (parseFloat(a.x) - parseFloat(b.x)) )
                    this.chartData.datasets[0].data.forEach( (obj,i) =>   {
                        if(response.data["ticks"] == 0.1){
                            this.chartData.datasets[0].data[i].x = String(parseFloat(obj.x).toFixed(1))
                        }
                    })

                    this.chartData.datasets[1].data.sort((a, b) => (parseFloat(a.x) - parseFloat(b.x)) )
                    this.chartData.datasets[1].data.forEach( (obj,i) =>   {
                        if(response.data["ticks"] == 0.1){
                            this.chartData.datasets[1].data[i].x = String(parseFloat(obj.x).toFixed(1))
                        }
                    })

                    let closestValueX = null;
                    if(this.currentFund[this.selector]) {
                        closestValueX = list.reduce((prev, curr) => Math.abs(curr - parseFloat(this.currentFund[this.selector])) < Math.abs(prev - parseFloat(this.currentFund[this.selector])) ? curr : prev);
                        this.chartData.datasets[2].data[0] = Object.assign({}, {x: closestValueX, y:1})
                    }
                    else {
                        this.chartData.datasets[2].data[0] = Object.assign({}, {x: 0, y:1})
                    }
                    this.renderChart(this.chartData, this.options)
                })
                .catch(() => {
                })
        },
    },
    mounted() {
        this.getChart()
    },
    watch:{
        selector(){
            this.getChart()
        }
    }
}
</script>
